module.exports = __webpack_public_path__ + "static/media/Left.f51afb54.svg";